import React from 'react';

import roundToGivenDecimals from 'common/roundToGivenDecimals';

import './Reward.scss';

type IReward = {
  name: string,
  amount: number,
  inDollars: number | null,
}

const Reward = ({ name, amount, inDollars }: IReward) => (
  <div className='reward'>
    <h5>{name}</h5>
    <h3>{amount.toFixed(8)} <span>BTC</span></h3>
    {inDollars !== null && (
      <div className='in-dollars'>≈ {roundToGivenDecimals(inDollars, 2)} USD</div>
    )}
  </div>
);

export default Reward;
